<template>
  <div class="appointManage">
    <div class="bodycontent">
      <!-- 预约记录列表 -->
      <el-table :data="listData">
        <el-table-column label="船名" prop="device_name"></el-table-column>
        <el-table-column label="预约时间">
          <template slot-scope="scope">
            <span v-text="setTime(scope.row.apply_time)"></span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile"></el-table-column>
        <el-table-column label="预约站点" prop="offlineroom.name"></el-table-column>
        <el-table-column label="数量(吨)" prop="num"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.status == 0">已预约</el-tag>
            <el-tag size="small" v-if="scope.row.status == 2">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="editItem(scope.row.id)">查看</el-button> -->
            <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { appointList, appointDel} from "@/api/vip";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      radio: "",
      imageUrl: "",
      headline: "",
      is_show: "", //类型筛选
      listData: [], //列表
      keyword: "", //关键字筛选
      page: 0,
      total: 0,
      showSet: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    setTime(fmt) {
      const time = new Date(fmt * 1000);
      const Y = time.getFullYear();
      const M = (time.getMonth() + 1).toString().padStart(2, "0");
      const D = time
        .getDate()
        .toString()
        .padStart(2, "0");
      const h = time
        .getHours()
        .toString()
        .padStart(2, "0");
      const m = time
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const s = time
        .getSeconds()
        .toString()
        .padStart(2, "0");
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    },
    getList() {
      this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: "",
        store_id: 0,
        page: this.page
      }
      appointList(data).then(res => {
        console.log(res);
        this.listData = res.data.result;
      })
    },
    search() {},
    //跳页
    handleCurrentChange(p) {},

    //删除
    delItem(i) {
      appointDel({
        token: this.token,
        app_id: this.app_id,
        id: i
      }).then(res => {
        console.log(res);
        this.page = 0;
        this.getList();
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.appointManage {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .grid-content {
    min-height: 36px;
    margin-top: 15px;
    font-size: 16px;
    .width100 {
      width: 100%;
    }
  }
  .bg-purple {
    text-align: right;
  }
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
}
</style>

<style lang="scss">
.appointManage {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
